import React from 'react';
import { toMMDDYYYY } from '../utils/dateFormat';
import { formatCurrency } from '../utils/formatCurrency';
import '../styles/transaction.css';

function AllTransactionsModal({ store, onClose }) {
  const transactions = store.transactions || [];
  
  const totalIncome = transactions
    .filter(t => t.type === 'income')
    .reduce((sum, t) => sum + t.amount, 0);
  
  const totalExpense = transactions
    .filter(t => t.type === 'expense')
    .reduce((sum, t) => sum + t.amount, 0);
  
  const netAmount = totalIncome - totalExpense;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="all-transactions-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>📊 All Transactions - {store.name || store.storeCode}</h3>
          <button className="modal-close" onClick={onClose}>✕</button>
        </div>

        <div className="transaction-summary">
          <div className="summary-item income">
            <div className="summary-label">Total Income</div>
            <div className="summary-value">+${formatCurrency(totalIncome)}</div>
          </div>
          <div className="summary-item expense">
            <div className="summary-label">Total Expense</div>
            <div className="summary-value">-${formatCurrency(totalExpense)}</div>
          </div>
          <div className="summary-item net">
            <div className="summary-label">Net Amount</div>
            <div className="summary-value">${formatCurrency(netAmount)}</div>
          </div>
          <div className="summary-item balance">
            <div className="summary-label">Current Balance</div>
            <div className="summary-value">${formatCurrency(store.bal)}</div>
          </div>
        </div>

        <div className="modal-body">
          {transactions.length > 0 ? (
            <div className="all-transactions-list">
              {transactions.map(t => (
                <div key={t.id} className="transaction-list-item">
                  <div className="transaction-list-type">
                    {t.type === 'income' ? '➕' : '➖'}
                  </div>
                  <div className="transaction-list-info">
                    <div className="transaction-list-desc">{t.desc}</div>
                    <div className="transaction-list-date">{toMMDDYYYY(t.date) || t.date}</div>
                  </div>
                  <div className={`transaction-list-amount ${t.type}`}>
                    {t.type === 'income' ? '+' : '-'}${formatCurrency(Math.abs(t.amount))}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-transactions">
              <div className="empty-icon">📊</div>
              <div>No transactions yet</div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-cancel" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default AllTransactionsModal;